export default {
  state: {
    report: {
      sectors: []
    }
  },
  mutations: {
    addCoverageReportSector (state, value) { state.report.sectors.push(value) },
    setCoverageReportSectors (state, value) { state.report.sectors = value }
  }
}



// WEBPACK FOOTER //
// ./src/store/coverage/coverage-report.js